import React, { useState } from "react";
import PrincipalEntityList from "../component/principalentity/PrincipalEntityList";
import { useCreatePrincipalEntriesMutation } from "../store/services/principleApi";
import {
  TextField,
  Button,
  Typography,
  Container,
  Box,
  Alert,
  CircularProgress,
} from "@mui/material";
import CommonModal from "../component/common/commonModal";
import { toast } from "react-toastify";
import { layoutCSS } from "../component/common/commonStyle";
const PrincipalEntity = () => {
  const [createPrincipal] = useCreatePrincipalEntriesMutation();
  const [PEName, setPEName] = useState("");
  const [principalId, setPrincipalId] = useState("");
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [apiMessage, setApiMessage] = useState("");
  const [openForm, setOpenForm] = useState(false);

  const validateForm = () => {
    const errors = {};

    if (!PEName) {
      errors.PEName = "Principal Entity Name is required.";
    } else if (PEName.length < 3 || PEName.length > 15) {
      errors.PEName =
        "Principal Entity Name must be between 3 and 15 characters long.";
    }

    if (!principalId) {
      errors.principalId = "Principal ID is required.";
    } else if (principalId.length < 2 || principalId.length > 50) {
      errors.principalId =
        "Principal ID must be between 2 and 50 characters long.";
    } else if (!/^[a-zA-Z0-9]+$/.test(principalId)) {
      errors.principalId =
        "Principal ID can only contain alphanumeric characters.";
    }

    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async (e) => {
    // e.preventDefault();

    if (!validateForm()) return;

    setLoading(true);
    setErrors({});
    setApiMessage("");

    const data = {
      pe_id: principalId,
      pe_name: PEName,
    };
    const response = await createPrincipal(data);
    console.log({ response });
    if (response?.data?.data) {
      setOpenForm(false);
      toast.success(
        response?.data?.message || "Principal Entity created successfully.",
      );
      setLoading(false);
    } else {
      console.error("Failed to create Principal Entity:", response);
      setOpenForm(false);
      toast.error(
        response?.error?.data?.message || "Failed to create Principal Entity.",
      );
      setLoading(false);
    }

    // try {

    //   if (response.status >= 200 && response.status < 300) {
    //     setApiMessage({
    //       type: "success",
    //       message: response.data.message || "Principal Entity created successfully",
    //     });
    //   }
    // } catch (error) {
    //   if (error.response) {
    //     setApiMessage({
    //       type: "error",
    //       message: error.response.data.message || "An error occurred.",
    //     });
    //   } else {
    //     setApiMessage({
    //       type: "error",
    //       message: "Network error or server is unreachable.",
    //     });
    //   }
    // } finally {
    //   setLoading(false);
    //   setPEName("");
    //   setPrincipalId("");
    // }
  };

  return (
    <Box sx={layoutCSS}>
      <Typography
        variant="h6"
        sx={{
          mb: 2,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          fontSize: "0.9rem",
          fontWeight: "bold",
        }}
      >
        <span>Manage Entity</span>
        <Button
          variant="contained"
          color="primary"
          onClick={() => setOpenForm(true)}
          sx={{ ml: 2, height: 40, fontSize: "0.75rem", textTransform: "none" }}
        >
          New Entity
        </Button>
      </Typography>

      {/* CommonModal to Add Principal Entity */}
      <CommonModal open={openForm} setOpen={setOpenForm}>
        <Box sx={{ p: 2 }}>
          {errors.PEName && (
            <Typography
              variant="caption"
              color="error"
              sx={{ mb: 1, display: "block", fontSize: "0.7rem" }}
            >
              {errors.PEName}
            </Typography>
          )}
          <TextField
            label="Entity Name"
            variant="outlined"
            fullWidth
            required
            value={PEName}
            onChange={(e) => setPEName(e.target.value)}
            size="small"
            sx={{
              mb: 2,
              "& .MuiInputBase-input": { fontSize: "0.75rem" },
              "& .MuiInputLabel-root": { fontSize: "0.75rem" },
            }}
          />

          {errors.principalId && (
            <Typography
              variant="caption"
              color="error"
              sx={{ mb: 1, display: "block", fontSize: "0.7rem" }}
            >
              {errors.principalId}
            </Typography>
          )}
          <TextField
            label="Entity ID"
            variant="outlined"
            fullWidth
            required
            value={principalId}
            onChange={(e) => setPrincipalId(e.target.value)}
            size="small"
            sx={{
              mb: 3,
              "& .MuiInputBase-input": { fontSize: "0.75rem" },
              "& .MuiInputLabel-root": { fontSize: "0.75rem" },
            }}
          />

          <Box
            sx={{ display: "flex", justifyContent: "space-between", gap: 1 }}
          >
            <Button
              variant="contained"
              color="primary"
              disabled={loading}
              fullWidth
              sx={{
                fontSize: "0.7rem",
                textTransform: "none",
                bgcolor: loading ? "grey.400" : "#1976d2",
              }}
              onClick={handleSubmit}
            >
              Submit
            </Button>
            <Button
              onClick={() => setOpenForm(false)}
              color="error"
              variant="outlined"
              fullWidth
              sx={{ fontSize: "0.7rem", textTransform: "none" }}
            >
              Cancel
            </Button>
          </Box>
        </Box>
      </CommonModal>

      {/* Show API message */}
      {apiMessage && (
        <Alert
          severity={apiMessage.type === "success" ? "success" : "error"}
          sx={{ mt: 2 }}
        >
          {apiMessage.message}
        </Alert>
      )}

      <PrincipalEntityList />
    </Box>
  );
};

export default PrincipalEntity;
